var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.25C7.5 8.36438 7.5 7.42157 8.08579 6.83579C8.67157 6.25 9.61438 6.25 11.5 6.25H33.5C35.3856 6.25 36.3284 6.25 36.9142 6.83579C37.5 7.42157 37.5 8.36438 37.5 10.25V37.75C37.5 40.5784 37.5 41.9926 36.6213 42.8713C35.7426 43.75 34.3284 43.75 31.5 43.75H13.5C10.6716 43.75 9.25736 43.75 8.37868 42.8713C7.5 41.9926 7.5 40.5784 7.5 37.75V10.25Z",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 37.5L28.125 43.75M16.875 37.5L16.875 43.75",
    stroke: "#222222",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 16.6665L28.125 16.6665",
    stroke: "#222222",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 25L28.125 25",
    stroke: "#222222",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatch);
export default __webpack_public_path__ + "static/media/Dispatch.07ae4e5f032b08b25a306b37f1502f57.svg";
export { ForwardRef as ReactComponent };